module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"filters":"Filtres","sort":"Trier par"},"en":{"filters":"Filters","sort":"Sort by"},"de":{"filters":"Filter","sort":"Sortieren nach"},"es":{"filters":"Filtros","sort":"Filtrar por"},"it":{"filters":"Filtri","sort":"sort by"},"nl":{"filters":"Filteren","sort":"Sorteren op"},"pt":{"filters":"Filtros","sort":"Filtrar por"}}')
  delete Component.options._Ctor
}
